import { MessageBox, Loading } from 'element-ui'
import { asyncSave } from "@/api/resources";
import secret from "@/utils/secret.js";
const IMAGE_FORMAT_LIST = ['jpg', 'jpeg', 'png', 'mp', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp']

const utils = {
}
/** 消息提示方法 */
utils.msgAlert = function (type, msg) {
  MessageBox.alert(msg, '提示', {
    confirmButtonText: '确定',
    type: type,
    callback: action => {
    }
  })
}

utils.Loading = function (tipsMsg) {
  const loading = Loading.service({
    lock: true,
    text: tipsMsg,
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return loading
}

/** 拼接axios请求参数配置 */
utils.getAxiosOption = function (method, url, params, data) {
  var option = {
    method: method,
    url: url,
    params: params,
    data: data
  }
  return option
}

/** 格式化时间 */
utils.dateFmt = function (fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/** 生成guid */
utils.guid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

utils.positionUUid = function () {
  return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/** 生成UUID */
utils.uuid = function () {
  var s = []
  var hexDigits = localStorage.getItem('cabptoken')
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

/** 不为空的判断 */
utils.isNotEmpty = function (param) {
  // console.log('不为空的判断',param)
  var falg = false
  if (param !== '' && param !== undefined && param !== null && param.length > 0) {
    falg = true
  }
  return falg
}

/** 获取数组中的目标数据，数组格式 [{id: 1},{id: 2}] */
utils.getOptionItemInArray = function (arrayData, validField, validContent) {
  let targetObj = {}
  targetObj = arrayData.find((item) => {
    return item[validField] == validContent
  })
  return targetObj
}

/** 获取数组中目标数据索引 */
utils.getOptionIndexInArray = function (arrayData, validField, validContent) {
  let changeIndex = -1
  changeIndex = arrayData.findIndex((item, index) => {
    return item[validField] == validContent
  })
  return changeIndex
}

/** 移除数组中的目标数据 */
utils.reduceOptionItemInArray = function (arrayData, validField, validContent) {
  if (arrayData.length > 0) {
    for (let i = 0; i < arrayData.length; i++) {
      if (arrayData[i][validField] == validContent) {
        arrayData.splice(i, 1)
      }
    }
  }
}

/** 设置图片宽高 */
utils.DrawImage = function (ImgObj, maxWidth, maxHeight) {
  var image = new Image();
  // 元图片原始地址（用于获取原图片的真实宽高，当<img>标签制定了宽、高时不受影响
  image.src = ImgObj.src;
  // 用于设定图片的宽度和高度
  var tempWidth;
  var tempHeight;

  if(image.height > 0 && image.width/image.height > 0) {
    // 原图片宽高比例大于指定的宽高比例，这就说明了原图片的宽度必然大于高度
    if(image.width/image.height >= maxWidth/maxHeight) {
      if(image.width > maxWidth){
        tempWidth = maxWidth;
        // 按原图片的大小进行缩放
        tempHeight = (image.height*maxWidth) / image.width;
      }else{
        // 按原图片的大小进行缩放
        tempWidth = image.width;
        tempHeight = image.height;
      }
    } else {
      // 原图片的高度必然大于宽度
      if(image.height > maxHeight){
        tempHeight = maxHeight;
        // 按原图片的比例进行缩放
        tempWidth = (image.width*maxHeight) / image.height;
      }else{
        // 按原图片的比例进行缩放
        tempWidth = image.width;
        tempHeight = image.height;
      }
    }
    // 设置页面图片的宽和高
    ImgObj.height = tempHeight;
    ImgObj.width = tempWidth;
  }
}

/** 处理图片的加载-限宽 */
utils.dealImageSizeLoaded = function (images, maxWidth) {
  for (let itemImg of images) {
    let ItemSrc = itemImg.src
    let image = new Image()
    image.src = ItemSrc
    let notLoadedImage = (image.height === 0 || image.width / image.height === 0)
    if (notLoadedImage) {
      return false
    } else {
      utils.drawImageWH(itemImg, maxWidth, 0)
    }
  }
  return true;
},
/** 处理图片的加载-限宽高 */
utils.dealImageWHSizeLoaded = function (images, maxWidth, maxHeight) {
  for (let itemImg of images) {
    let itemSrc = $(itemImg).attr('data-original')
    if (utils.validIsExistImage(itemSrc)) {
      let image = new Image()
      image.src = itemSrc
     image.onload=function() {
      let notLoadedImage = (image.height === 0 || image.width / image.height === 0)
      console.log(notLoadedImage)
      if (notLoadedImage) {
        return false
      } else {
        utils.drawImageWH(itemImg, maxWidth, maxHeight)
      }
     }
    }
  }
  return true;
},
/** 重新设置图片的宽高 */
utils.drawImageWH = function (imgObj, maxWidth, maxHeight) {
  let image = new Image();
  image.src = $(imgObj).attr('data-original');
  image.onload = function () {
    let tempWidth;
  let tempHeight;
  let isLoadedImage = (image.height > 0 && (image.width / image.height > 0))
  console.log(isLoadedImage)
  if (isLoadedImage) {
    if (maxHeight === 0) {
      if (image.width > maxWidth) {
        tempWidth = maxWidth
        tempHeight = (image.height * maxWidth) / image.width
      } else {
        tempWidth = image.width
        tempHeight = image.height
      }
    } else {
      if ((image.width / image.height) >= (maxWidth / maxHeight)) {
        if (image.width > maxWidth) {
          tempWidth = maxWidth
          tempHeight = (image.height * maxWidth) / image.width
        } else {
          tempWidth = image.width
          tempHeight = image.height
        }
      } else {
        if (image.height > maxHeight) {
          tempHeight = maxHeight
          tempWidth = (image.width * maxHeight) / image.height
        } else {
          tempWidth = image.width
          tempHeight = image.height
        }
      }
    }
    let imgJq = $(imgObj)
    // 处理缩图逻辑
    let oldWidth = imgJq.css('width')
    let oldHeight = imgJq.css('height')
    let cssWidth = tempWidth + 'px'
    let cssHeight = tempHeight + 'px'
    if (utils.isNotEmpty(oldWidth) && oldWidth < maxWidth) {
      cssWidth = oldWidth
    }
    if (utils.isNotEmpty(oldHeight) && oldHeight < maxHeight) {
      cssHeight = oldHeight
    }

    let imgAlt = imgJq.attr('alt')
    let imgTitle = imgJq.attr('title')
    if (!utils.isNotEmpty(imgTitle) && utils.isNotEmpty(imgAlt)) {
      imgJq.attr('title', imgAlt)
    }
    imgJq.css({ width: cssWidth + 'px', height: cssHeight + 'px' })
    imgJq.height(cssHeight)
    imgJq.width(cssWidth)
    console.log(imgJq)
    console.log(cssWidth,cssHeight)
  }
  }
}
/** 判断是否是图片 */
utils.validIsExistImage = function (imageSrc) {
  let srcPonitIndex = imageSrc.lastIndexOf('.') + 1
  let substrSrc = imageSrc.substr(srcPonitIndex, imageSrc.length)
  let index = $.inArray(substrSrc, IMAGE_FORMAT_LIST)
  if (index > -1) {
    return true
  } else {
    return false
  }
}
/**未登录的时候去登陆**/
utils.toLogin =  function(text,currentPageText,platform,appCode,fullPath) {
  var READ_PLATFORM_PATH =
    process.env.READ_PLATFORM_PATH + fullPath;
  var redirectUrl = secret.encryptionText(READ_PLATFORM_PATH);
  let login = () => {
    if (appCode == "sztsg") {
      if(platform == 'mweb'){
        window.location.href = process.env.JGSSO_WEB_URL + "/mobileLogin?redirectUrl=" + redirectUrl;
      }else{
        window.location.href = process.env.JGSSO_WEB_URL + "/login?redirectUrl=" + redirectUrl;
      }
    } else {
      if(platform == 'mweb'){
        window.location.href = process.env.SSO_WEB_URL + "/mobileLogin?redirectUrl=" + redirectUrl;
      }else{
        window.location.href = process.env.SSO_WEB_URL + "/login?redirectUrl=" + redirectUrl;
      }
    }
  };
  utils.asyncSave(
    appCode,
    window.location.origin + window.location.pathname,
    currentPageText,
    '未登录-'+text,
    window.sessionStorage.getItem("previousUrl"),
    platform,
    login
  );
}
// 秒转时间格式
utils.second_to_time = function(second_number){
    let str = new Date(second_number*1000).toJSON();
    return typeof str == 'string' ? str.substring(11,19) : '';
},
/** 添加用户访问日志 */
utils.asyncSave = function (appCode,url,name,buttonName,previousUrl,platform,callback) {
  asyncSave('',{
    "appCode": appCode,
    "url": url,
    "name": name,
    "buttonName": buttonName,
    "previousUrl" : previousUrl,
    "platform":platform
  }).then(res => {
    if(res.data.errorInfo){
      //callback存在 有需要再执行的内容
      if(callback){
        callback()
      }
    }
  });
}
utils.getToReadUrlByCategory = (category, params,type) => {
  // 品类CODE
  let constant = {}
  constant.pl_ts = 'ts' // 图书
  constant.pl_ptts = 'ptts' // 普通图书
  constant.pl_gf = 'bz' // 规范
  constant.pl_al = 'al' // 案例
  constant.pl_xxzl = 'xxzl' // 学习资料
  constant.pl_tuku = 'tuku' // 图库ptts
  constant.pl_qk = 'qk' // 期刊
  constant.pl_ksjc = 'ksjc' // 考试教材
  constant.pl_sp = 'sp' // 视频
  constant.pl_yp = 'yp' // 音频
  constant.pl_ypk = 'ypk' // 音频课
  constant.pl_kejian = 'kj' // 课件
  constant.pl_st = 'st' // 试题
  constant.pl_sj = 'sj' // 试卷
  constant.pl_xt = 'xt' // 习题
  constant.pl_tk = 'tk' // 题库
  constant.pl_kec = 'ck' // 课程
  constant.pl_zlj = 'zlj' // 室内设计 室内设计资料集（第二版）
  constant.pl_hpjzxbsjtk = 'tuku' // 室内设计 海派建筑细部设计图库
  constant.pl_wz = 'wz' // 文章
  constant.pl_lxcbw = 'lxcbw' // 连续出版物
  constant.pl_ptzy = 'ptzy' // 配套资源
  let readType = {
    onLineLS:'/service',
    onLineBS:'/readerPDF'
  }
  let readTypeH5 = {
    onLineLS:'/read_al',
    onLineBS:'/mreaderPDF'
  }
  console.log("rrrrrs", category, params,type)
  let toReadPath = process.env.READ_PLATFORM_PATH
  if ((constant.pl_kec == category) || (constant.pl_sp == category) || (constant.pl_yp == category) || (constant.pl_ypk == category)) { //课程或者视频
    toReadPath += '/read_cl?resourceId=' + params.resourceId + '&type=' + category
  } else if ((constant.pl_sj == category)) { //试卷
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExamStart?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExam?resourceId=' + params.resourceId + '&type=' + category
    }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else if ((constant.pl_al == category)||(constant.pl_xxzl == category) || (constant.pl_ts == category)||constant.pl_gf == category||constant.pl_lxcbw == category||constant.pl_wz == category||constant.pl_ptzy == category) { //案例/图书/规范/连续出版物/文章/配套资源
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += readTypeH5[type]+'?resourceId=' + params.resourceId + '&type=' + category
    } else {
      console.log("11111111133333", readType[type])
      toReadPath += readType[type]+'?resourceId=' + params.resourceId + '&type=' + category
    }
  }else if ((constant.pl_zlj == category) ) { //资料集
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    toReadPath += '/mCatalog?resourceId=' + params.resourceId + '&type=' + category
    }else{
    toReadPath += '/pcCatalog?resourceId=' + params.resourceId + '&type=' + category
    }
  } else if ((constant.pl_xt == category)) { //习题
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExercises?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExercises?resourceId=' + params.resourceId + '&type=' + category
      }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else {
    toReadPath = ''
  }
  delete params["resourceId"]
  if (utils.isNotEmpty(toReadPath)) {
    for (let paramIndex in params) {
      toReadPath += '&' + paramIndex + '=' + params[paramIndex]
    }
  }
  return toReadPath
}
// 下载接口返回的流文件 (  接口返回的流,   文件名.带扩展名  ) 
utils.downloadBinary = function (data, filename) {
  const typs = {
    xls:  'application/vnd.ms-excel;charset=utf-8',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
    doc:  'application/msword;charset=utf-8',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8',
    pdf:  'application/pdf',
    txt:  'text/plain;charset=utf-8',
  }
  const blob = new Blob([data], { type: typs[filename.slice(filename.lastIndexOf('.')+1)]});
  const downloadElement = document.createElement("a");
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = filename;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement); 
  window.URL.revokeObjectURL(href); 
}
export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js